import React from 'react';
import { useTranslation } from 'react-i18next';

import './GrowFeatures.css';

const INSIGHTS_IMAGE = 'https://haatnexusprodinfosys.blob.core.windows.net/images/6.png';
const SUPPORT_IMAGE =
  'https://haatnexusprodinfosys.blob.core.windows.net/images/5%20(1).png';

/**
 * "Everything you need to grow" landing section presenting the Insights and
 * Support value propositions, each paired with an illustration.
 *
 * Rows are a two-column grid that follows the document direction, so the sides
 * mirror themselves in Hebrew and Arabic. The copy always comes first in the
 * DOM for reading order; `.row--media-first` only flips the visual columns.
 */
const GrowFeatures: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="grow-features">
      <div className="wrap">
        <h1>{t('landingSections.growFeatures.heading')}</h1>

        <section className="row">
          <div className="copy">
            <h2>{t('landingSections.growFeatures.insights.title')}</h2>
            <p className="lead">{t('landingSections.growFeatures.insights.body')}</p>
          </div>
          <img
            className="media"
            src={INSIGHTS_IMAGE}
            alt={t('landingSections.growFeatures.insights.imageAlt') as string}
            loading="lazy"
            decoding="async"
          />
        </section>

        <section className="row row--media-first">
          <div className="copy">
            <h2>{t('landingSections.growFeatures.support.title')}</h2>
            <p className="lead">{t('landingSections.growFeatures.support.body')}</p>
          </div>
          <img
            className="media"
            src={SUPPORT_IMAGE}
            alt={t('landingSections.growFeatures.support.imageAlt') as string}
            loading="lazy"
            decoding="async"
          />
        </section>
      </div>
    </section>
  );
};

export default GrowFeatures;
